"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTitle = void 0;
const react_1 = require("react");
function useTitle(title) {
    react_1.useEffect(() => {
        document.title = `${title} - Yanzi`;
    }, [title]);
}
exports.useTitle = useTitle;
//# sourceMappingURL=useTitle.js.map